import { styled } from '@mui/material';
import { SplitViewIcon } from '../../../../icon/SplitViewIcon';
import { SingleViewIcon } from '../../../../icon/SingleViewIcon';
import { typographyStyles } from '../../DataGridScanStatusField/styles';

export const Wrapper = styled('div')`
  padding: 26px 32px;
`;

export const Header = styled('div')`
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 26px;
`;

export const HeaderLeft = styled('div')`
  display: flex;
  gap: 16px;
  align-items: center;
  z-index: 1;
`;

export const MeshViewContainer = styled('div')`
  position: relative;
`;

export const LoadingContainer = styled('div')`
  position: absolute;
  z-index: 1000;
  height: 100%;
  width: 100%;
`;

export const CustomSplitViewIcon = styled(SplitViewIcon)(({ theme }) => ({
  ...typographyStyles(theme),
}));

export const CustomSingleViewIcon = styled(SingleViewIcon)(({ theme }) => ({
  ...typographyStyles(theme),
}));
